export const tr = {
    bannersEdit: 'Reklamların düzenlenmesi',
    campaignsEdit: 'Kampanya düzenleme',
    clientHistory: 'Değişiklikler listesi',
    clientsReports: 'Müşterilere göre rapor',
    deals: 'Anlaşma listesi',
    domainsReports: 'Alan adlarına göre rapor',
    freelancerCard: 'Yandex.Direct uzmanı',
    freelancerCardEdit: 'Uzman anketi',
    freelancerCustomers: 'Müşteri listesi',
    freelancersList: 'Yandex.Direct ayarlama uzmanları',
    groupsEdit: 'Reklam gruplarının düzenlenmesi',
    'import-export-wizard': 'Veri Aktarma Sihirbazı',
    marketerCard: 'Pazarlamacı kartı',
    marketers: 'Pazarlamacı yönetimi',
    minusPhrasesLibrary: 'Negatif anahtar sözcük grubu arşivi',
    mobileAppsCreate: 'Mobil uygulama ekle',
    mobileAppsEdit: 'Uygulamanın görüntülenmesi',
    mobileAppsList: 'Mobil uygulamalar',
    myVideos: 'Videolarım',
    offlineReports: 'Çevrimdışı raporlar',
    pricePackages: 'Paket listesi',
    pricePackagesEdit: 'todo',
    products: 'Ürün yönetimi',
    recommendationsItems: 'Öneriler',
    recommendationsPage: 'Öneriler',
    tools: 'Araçlar',
    'user-settings': 'Kullanıcı ayarları',
    videoCreate: 'Video oluşturun',
    videoTemplates: 'Şablonlar',
    welcome: "Yandex.Direct'e hoş geldiniz!"
};
